import React, { Component } from 'react';
import { Editors, Filters, Toolbar } from 'react-data-grid-addons';

import { formatEuro, formatDate } from './../DataGrid/Format';
import { ConseilorEditor, LoyaltyConquestEditor, ModelEditor, ShortnameEditor, TypeEditor } from './../DataGrid/Editors';
import DateEditor from './../DataGrid/DateEditor';
import ClientEditor from './../DataGrid/ClientEditor';
import BooleanFilter from './../DataGrid/BooleanFilter';
// import DateFilter from './../DataGrid/DateFilter';

const { DropDownEditor, CheckboxEditor } = Editors;
const { NumericFilter, AutoCompleteFilter, MultiSelectFilter, SingleSelectFilter } = Filters;

const MainColumns = (
  handleCheckbox: Function,
  conseilors: Array<Object>,
  dealerships: Array<Object>,
  models: Array<Object>,
) => {
  return [
    {
      key: 'type',
      name: 'Type',
      resizable: true,
      width: 60,
      editable: true,
      sortable: true,
      filterable: true,
      filterRenderer: SingleSelectFilter,
      editor: TypeEditor(),
    },
    {
      key: 'shortname',
      name: 'Affaire',
      resizable: true,
      width: 170,
      editable: true,
      sortable: true,
      filterable: true,
      filterRenderer: AutoCompleteFilter,
      editor: ShortnameEditor(dealerships),
    },
    {
      key: 'conseilor',
      name: 'Vendeur',
      resizable: true,
      width: 180,
      editable: true,
      sortable: true,
      filterable: true,
      filterRenderer: AutoCompleteFilter,
      editor: ConseilorEditor(conseilors),
    },
    {
      key: 'date',
      name: 'Date',
      resizable: true,
      editable: true,
      sortable: true,
      width: 110,
      formatter: formatDate,
      // filterable: true,
      // filterRenderer: DateFilter,
      editor: DateEditor,
    }, //Date
    {
      key: 'name',
      name: 'Nom du client',
      resizable: true,
      width: 230,
      editable: true,
      sortable: true,
      filterable: true,
      filterRenderer: AutoCompleteFilter,
      editor: ClientEditor,
    },
    {
      key: 'model',
      name: 'Modèle',
      resizable: true,
      width: 220,
      editable: true,
      sortable: true,
      filterable: true,
      filterRenderer: AutoCompleteFilter,
      editor: ModelEditor(models),
    },
    {
      key: 'price',
      name: 'Prix tarif',
      resizable: true,
      width: 90,
      editable: true,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'discount',
      name: 'Remise + surestim',
      resizable: true,
      // width: 90,
      editable: true,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'gap_aids',
      name: 'Ecart VPP',
      resizable: true,
      // width: 100,
      editable: false,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'average_gap_vd',
      name: 'Ecart VD',
      resizable: true,
      // width: 100,
      sortable: true,
      editable: false,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'average_gap_so',
      name: 'Ecart SO',
      resizable: true,
      // width: 100,
      sortable: true,
      editable: false,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'actions',
      name: '',
      resizable: true,
      width: 80,
    }
  ];
};

export default MainColumns;



// WEBPACK FOOTER //
// ./src/Components/Proposal/MainColumns.js